











import Vue from 'vue'

export default Vue.extend({
  name: 'CompetenceQualityCellRenderer',

  computed: {
    stars (): number {
      return 5
    },

    selectedQuality (): any {
      // @ts-ignore
      const data: any = this.params.data.agreementData
      const index: number = data.length - 1
      const selectedQuality: any = data[index]
      return selectedQuality ? selectedQuality : {description:'', quality: 0}
    }

  }

})
